import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";

import { useTranslate } from "src/locales";
import ByzMuiTypography from "../../inputs/ByzMuiTypography";

// BKARADENIZ;440298;17.03.2025
interface ByzOkeyButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const StyledOkeyButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "hoverState",
})<{ hoverState?: boolean }>(({ hoverState }) => ({
  color: "white",
  backgroundColor: hoverState ? "#AE4242" : "#B71C1C",
  opacity: hoverState ? 1 : 0.9,
  transition: "0.2s ease-in-out",
  "&:hover": {
    backgroundColor: "#AE4242",
    opacity: 1,
  },
}));

const ByzOkeyButton = ({ onClick, disabled, loading }: ByzOkeyButtonProps) => {
  const { t } = useTranslate();
  const [hover, setHover] = useState(false);

  return (
    <StyledOkeyButton
      onClick={onClick}
      hoverState={hover}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      disabled={disabled || loading}
    >
      {loading ? (
        <CircularProgress size={24} color="inherit" />
      ) : (
        <ByzMuiTypography fontWeight={400} marginLeft="0px">
          {t("buttons.okey")}
        </ByzMuiTypography>
      )}
    </StyledOkeyButton>
  );
};

export default ByzOkeyButton;
